module.exports = __webpack_public_path__ + "static/banner-1-45ce0d03d3595239dafd3b3d961038fe.jpg";